import { Helmet } from "react-helmet-async"
import { Grid } from "src/components"
import BaseComponent from "src/core/base.component"
import { translate } from "src/i18n/tHelper"
import { useAppSelector } from "src/store"
import SonucIzlemeTanimEkle from "./Ekle"
import SonucIzlemeTanimListe from "./Liste"


interface ISonucIzlemeTanimProps { }
const translatePath = "pages|genelTanimlar|sonucIzlemeTanim"
const SonucIzlemeTanim = (props: ISonucIzlemeTanimProps): JSX.Element => {

    const state = useAppSelector(state => state.sonucIzlemeTanim);

    return (
        <>
            <Helmet><title>{translate(translatePath, "Sonuç İzleme Tanımları")}</title></Helmet>
            <BaseComponent>
                {state.open && <SonucIzlemeTanimEkle />}
                <Grid container>
                    <Grid item>
                        <SonucIzlemeTanimListe />
                    </Grid>
                </Grid>
            </BaseComponent>
        </>
    )
}

export default SonucIzlemeTanim